/*
 * @Author:
 * @LastEditTime: 2022-07-19 10:43:51
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class SceneCenter {
  // 查询场景列表
  static async getSceneList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Model_Scene/query_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增场景
  static async addScene(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/model_scene/add_model_scene', payload)
    )
    return Callback(err, res)
  }
  // 编辑场景
  static async editScene(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/model_scene/update_model_scene', payload)
    )
    return Callback(err, res)
  }
  // 获取场景详情
  static async getSceneDetail(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/model_scene/detail/${payload.id}`))
    return Callback(err, res)
  }
  // 删除场景
  static async deleteScene(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/model_scene/delete_model_scene', {
        data: payload.ids,
      })
    )
    return Callback(err, res)
  }
  // 获取指定文档下所有的动画文件
  static async getModelAnimations(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/document/filelist/${payload.documentId}/2`)
    )
    return Callback(err, res)
  }
}
